<button
  nbButton
  status="basic"
  class="dng-close-button"
  [disabled]="disabled"
  [size]="size"
>
  <nb-icon class="dng-close-button-icon" icon="close-outline"></nb-icon>
</button>
